@for (contact of contacts$ | async; track contact) {
  <div class="container">
    <meeting-analysis-participant [contact]="contact" [large]="large()"></meeting-analysis-participant>
  </div>
}
